import { Router } from '@angular/router';
import { CertificadosService } from '../../../services/certificados.service';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';
var CorviComponent = /** @class */ (function () {
    function CorviComponent(fb, dialog, _router, _certService) {
        this.fb = fb;
        this.dialog = dialog;
        this._router = _router;
        this._certService = _certService;
        this.rows = [];
        this.matcher = new FormService();
        this.form = new FormGroup({
            fecha: new FormControl(''),
            corvi: new FormControl('')
        });
        if (!JSON.parse(localStorage.getItem("corvi"))) {
            localStorage.setItem("corvi", JSON.stringify(this.rows));
        }
        else {
            this.rows = JSON.parse(localStorage.getItem("corvi"));
            // this.form.controls['fecha'].setValue(this.rows[0].fecha?this.rows[0].fecha:'');
            // this.form.controls['corvi'].setValue(this.rows[0].corvi?this.rows[0].corvi:'');
        }
        // this.corvi = {fecha: '',corvi:''};
    }
    CorviComponent.prototype.ngOnInit = function () {
        this.get_Corvi();
    };
    CorviComponent.prototype.get_Corvi = function () {
        var _this = this;
        this._certService.getCorviFM().subscribe(function (response) {
            console.log(response);
            if (response.message) {
                console.log("No existe corvi registrada a la fecha");
            }
            else {
                localStorage.setItem("corvi", JSON.stringify([]));
                _this.form.controls['fecha'].setValue(response.fecha ? moment(response.fecha).format('DD-MM-YYYY') : '');
                _this.form.controls['corvi'].setValue(response.corvi ? response.corvi : '');
                localStorage.setItem('corvi', JSON.stringify({ fecha: response.fecha, corvi: response.corvi }));
            }
        }, function (error) {
            console.log(error);
        });
    };
    CorviComponent.prototype.cleanData = function () {
        this.corvi = { fecha: '', corvi: '' };
    };
    CorviComponent.prototype.delete_corvi = function (id) {
        for (var x = 0; x < this.rows.length; x++) {
            if (id == x) {
                this.rows.splice(x, 1);
                localStorage.setItem("corvi", JSON.stringify(this.rows));
            }
        }
    };
    return CorviComponent;
}());
export { CorviComponent };
